import { observer } from "mobx-react-lite";
import { Button } from "@heroui/react";
import Icon from "@mdi/react";
import { mdiAlertOutline } from "@mdi/js";
import { contractorDetailStore } from "@/stores/ContractorDetailStore";

const NoLegalDataCard: React.FC = observer(() => {
  const { legal } = contractorDetailStore;

  return (
    <div className="scd-no-legal">
      <div className="scd-no-legal__icon-wrap">
        <Icon path={mdiAlertOutline} size={3.3} style={{ color: "#f59e0b" }} />
      </div>
      <p className="scd-no-legal__title">Юридические данные не заполнены</p>
      <p className="scd-no-legal__desc">
        Для полноценной работы с контрагентом необходимо заполнить юридические
        данные: реквизиты организации, адрес, сведения о руководителе и
        банковские реквизиты.
      </p>
      <Button
        variant="primary"
        onPress={() => legal.openDrawer()}
        className="scd-no-legal__btn"
      >
        Заполнить данные
      </Button>
    </div>
  );
});

NoLegalDataCard.displayName = "NoLegalDataCard";
export default NoLegalDataCard;
